(() => {
  const findVariant = (root, id) =>
    Array.from(root.querySelectorAll('[data-myraasa-variant]')).find((variant) => variant.dataset.id === id);

  const updateMetadata = (root, variant) => {
    for (const key of ['sku', 'dimensions', 'inventory']) {
      const row = root.querySelector(`[data-product-metadata="${key}"]`);
      if (!row) continue;
      const value = row.querySelector('[data-product-metadata-value]');
      const nextValue =
        key === 'inventory'
          ? (variant?.dataset.inventoryTracked === 'true' ? variant.dataset.inventoryQuantity : '')
          : (variant?.dataset[key] || '');
      value.textContent = nextValue;
      row.hidden = !nextValue;
    }
  };

  const updateRequestLink = (root, link, variant) => {
    const contactUrl = root.dataset.myraasaContactUrl;
    if (!link || !contactUrl || !variant) return;

    const destination = new URL(contactUrl, window.location.origin);
    destination.searchParams.set('request', 'made-to-order');
    destination.searchParams.set(
      'artwork',
      `${root.dataset.myraasaTitle} — ${new URL(root.dataset.myraasaUrl, window.location.origin).href}`
    );
    destination.searchParams.set('variant', variant.dataset.title || '');
    destination.hash = 'ContactForm';
    link.href = destination.toString();
  };

  const synchronize = (root) => {
    const variantId = root.querySelector('.product-variant-id')?.value;
    const variant = findVariant(root, variantId);
    const unavailable = !variant || variant.dataset.available !== 'true';
    const contactUrl = root.dataset.myraasaContactUrl;
    const nativePurchase = root.querySelector('[data-native-purchase]');
    const request = root.querySelector('.myraasa-made-to-order');
    const requestLink = root.querySelector('[data-made-to-order]');
    const fallback = root.querySelector('[data-request-unavailable]');
    const showRequest = unavailable && Boolean(contactUrl) && Boolean(variant);

    if (nativePurchase) nativePurchase.hidden = showRequest || !variant;
    if (request) request.hidden = !showRequest;
    if (fallback) fallback.hidden = !unavailable || showRequest;
    updateMetadata(root, variant);
    updateRequestLink(root, requestLink, variant);
  };

  const initialize = () => {
    document.querySelectorAll('[data-myraasa-product-request]').forEach(synchronize);
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.product-variant-id')) return;
    const root = event.target.closest('[data-myraasa-product-request]');
    if (root) synchronize(root);
  });
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  initialize();
})();
